module.exports = __webpack_public_path__ + "media/peao-do-bau-short.e28a431b.mp3";